import { useState } from "react";
import { Button, Typography, Container, Paper, Avatar, TextField, InputAdornment, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { SportsBasketball as BasketballIcon } from '@mui/icons-material';
import { getLoginUrl } from '../../api/api';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * 【TKG_RESERVE_0100】
 * @returns ログイン画面
 */
export const LoginScreen = () => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  // navigateを作成
  const navigate = useNavigate();

  // 現在のlocationオブジェクトを取得
  const location = useLocation();

  // location.searchは "?demo_mode=xxxx" のようなクエリ部分
  const queryParams = new URLSearchParams(location.search);

  // "demo_mode" パラメータを取得
  const demoMode = queryParams.get('demo_mode')?.toLowerCase() === 'true';

  /**
   * ボタンクリック時にサーバーサイドから取得したログイン用URLにリダイレクトする
   */
  const handleClick = () => {
    // デモモードかつ、デモ用パスワードが入力されている場合、デモログインを実施する
    if (demoMode && password) {
      navigate('/callback-receive?authorization_code=' + password);
    }
    // デモモードかつ、デモ用パスワードが入力されていない場合、アラートを表示する
    else if (demoMode) {
      alert('デモ用パスワードを入力してください。');
    }
    // デモモードでない場合、通常のログインを実施する
    else {
      getLoginUrl().then((response) => {
        window.location.href = response.message;
      });
    }
  };

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: '90vh',
        textAlign: 'center',
        paddingTop: '20vh'
      }}
    >
      {/* ロゴとタイトル */}
      <Avatar
        sx={{
          width: 100,
          height: 100,
          mb: 3,
          backgroundColor: '#FF9800',
        }}
      >
        <BasketballIcon sx={{ width: 50, height: 50, color: 'white' }} />
      </Avatar>
      <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#333', mb: 2 }}>
        ようこそ、社会人バスケサークルTKGへ！
      </Typography>
      <Typography variant="body1" sx={{ color: '#777', mb: 4 }}>
        公式LINEに登録しているLINEアカウントでログインしてください。
      </Typography>

      {/* ログインエリア */}
      <Paper
        elevation={3}
        sx={{
          p: 3,
          maxWidth: 400,
          width: '100%',
          borderRadius: 4,
          boxShadow: 3,
          backgroundColor: '#ffffff',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {/* デモモードの場合、パスワード入力フィールドを表示 */}
        {demoMode && (
          <TextField
            label="デモ用パスワード"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            variant="outlined"
            fullWidth
            sx={{ mb: 2 }}  // ここで下のボタンとの間に余白を追加
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        )}

        {/* ログインボタン */}
        <Button
          variant="contained"
          onClick={handleClick}
          sx={{
            backgroundColor: '#FF9800', // FFB74D
            color: 'white',
            padding: '12px 24px',
            borderRadius: '30px',
            width: '100%',
            boxShadow: 2,
            '&:hover': {
              backgroundColor: '#FFB74D', // FF9800
            },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textTransform: 'none',
          }}
        >
          ログインする
        </Button>
      </Paper>
    </Container>
  );
};
